import { allMovies } from '@/mocks/movies';
import SectionHeading from './SectionHeading';

const ranking = [...allMovies].sort((a, b) => b.heat - a.heat).slice(0, 10);
const maxHeat = ranking.length > 0 ? ranking[0].heat : 1;
const top = ranking[0];
const rest = ranking.slice(1);
const rankStyles = ['bg-primary-600', 'bg-primary-500', 'bg-accent-500'];

export default function HotRanking() {
  return (
    <section id="ranking" className="w-full bg-background-50 px-4 py-14 md:px-6 md:py-20">
      <div className="mx-auto max-w-6xl">
        <SectionHeading
          eyebrow="热播榜"
          title="热播榜：按近期热度排序的十部片单"
          desc="热度综合了关注度与讨论量的一般性指标，代表“最近被看到得多”，并不等于评分高。想追热门可以从榜首往下看，想避开爆款也可以从榜尾开始。"
        />

        <div className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-[1fr_1.1fr]">
          <div className="overflow-hidden rounded-lg border border-background-200 bg-background-100">
            <div className="relative h-[420px] w-full md:h-[560px]">
              <img
                src={top.poster}
                alt={`${top.title} 海报`}
                className="h-full w-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/25 to-transparent"></div>
              <span className="absolute left-4 top-4 inline-flex items-center gap-1 rounded-full bg-primary-600 px-3 py-1 text-xs font-medium text-background-50">
                <i className="ri-trophy-line text-sm" aria-hidden="true"></i>
                热播榜第 1 名
              </span>
              <div className="absolute inset-x-0 bottom-0 p-5">
                <h3 className="font-heading text-2xl font-bold text-background-50">{top.title}</h3>
                <p className="mt-1 text-xs text-background-50/75">
                  {top.origin} · {top.year} · {top.region}
                </p>
                <div className="mt-3 flex flex-wrap items-center gap-2">
                  <span className="rounded-full bg-background-50/15 px-2.5 py-0.5 text-[11px] text-background-50/90">
                    热度 {top.heat}
                  </span>
                  <span className="rounded-full bg-accent-500 px-2.5 py-0.5 text-[11px] font-medium text-accent-950">
                    评分 {top.score.toFixed(1)}
                  </span>
                  <span className="rounded-full bg-background-50/15 px-2.5 py-0.5 text-[11px] text-background-50/90">
                    {top.cinemaStatus}
                  </span>
                </div>
                <p className="mt-3 text-sm leading-relaxed text-background-50/85">{top.summary}</p>
              </div>
            </div>
          </div>

          <ul className="flex flex-col gap-2">
            {rest.map((movie, index) => {
              const rank = index + 2;
              const width = `${Math.round((movie.heat / maxHeat) * 100)}%`;
              return (
                <li key={movie.id}>
                  <div className="flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 px-3 py-3 transition-colors hover:border-primary-300 hover:bg-primary-50">
                    <span
                      className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-md font-heading text-sm font-bold ${
                        rankStyles[rank - 1] ?? 'bg-background-200 text-foreground-700'
                      }`}
                    >
                      {rank}
                    </span>
                    <span className="hidden h-14 w-10 shrink-0 overflow-hidden rounded-md sm:block">
                      <img src={movie.poster} alt={`${movie.title} 海报`} className="h-full w-full object-cover object-top" />
                    </span>
                    <span className="flex min-w-0 flex-1 flex-col">
                      <span className="flex items-center gap-2">
                        <span className="truncate font-heading text-sm font-bold text-foreground-950">{movie.title}</span>
                        <span className="shrink-0 text-xs text-accent-700">{movie.score.toFixed(1)} 分</span>
                      </span>
                      <span className="mt-0.5 truncate text-xs text-foreground-600">
                        {movie.genres.join(' · ')} · {movie.runtime}
                      </span>
                      <span className="mt-2 h-1.5 w-full overflow-hidden rounded-full bg-background-200">
                        <span className="block h-full rounded-full bg-primary-400" style={{ width }}></span>
                      </span>
                    </span>
                    <span className="hidden shrink-0 text-right text-xs text-foreground-500 md:block">
                      热度
                      <span className="mt-0.5 block font-medium text-foreground-800">{movie.heat}</span>
                    </span>
                  </div>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </section>
  );
}